import { z } from 'zod';
import { mediaTypeSchema, postCategorySchema, postTypeSchema } from '../enums.js';
/** Media is referenced by X CDN URL, never downloaded. */
export const postMediaSchema = z.object({
    type: mediaTypeSchema,
    url: z.string(),
    previewUrl: z.string().optional(),
    width: z.number().int().optional(),
    height: z.number().int().optional(),
    altText: z.string().optional(),
    durationMs: z.number().int().optional(),
});
export const postUrlEntitySchema = z.object({
    url: z.string(),
    expandedUrl: z.string().optional(),
    displayUrl: z.string().optional(),
    title: z.string().optional(),
    description: z.string().optional(),
    imageUrl: z.string().optional(),
});
export const postEntitiesSchema = z.object({
    urls: z.array(postUrlEntitySchema).default([]),
    hashtags: z.array(z.string()).default([]),
    mentions: z.array(z.string()).default([]),
    cashtags: z.array(z.string()).default([]),
});
export const postMetricsSchema = z.object({
    likes: z.number().int(),
    reposts: z.number().int(),
    replies: z.number().int(),
    quotes: z.number().int(),
    views: z.number().int(),
});
export const tagDtoSchema = z.object({
    id: z.string(),
    name: z.string(),
    color: z.string(),
});
/** Denormalised author block so a post can render without a second lookup. */
export const postAuthorSchema = z.object({
    targetId: z.string(),
    xUserId: z.string(),
    handle: z.string(),
    displayName: z.string(),
    avatarUrl: z.string().nullable(),
    verified: z.boolean(),
    color: z.string().nullable(),
});
/** Model-produced triage. Null until the classifier has run on the post. */
export const postAnalysisSchema = z.object({
    category: postCategorySchema,
    /** 0-100 within the category. */
    importance: z.number().int(),
    topics: z.array(z.string()),
    summary: z.string().nullable(),
    reasoning: z.string().nullable(),
    model: z.string(),
    analyzedAt: z.string(),
});
export const postDtoSchema = z.object({
    id: z.string(),
    /** Monotonic cursor — also the SSE event id used for `Last-Event-ID` replay. */
    seq: z.number().int(),
    xPostId: z.string(),
    type: postTypeSchema,
    text: z.string(),
    lang: z.string().nullable(),
    url: z.string(),
    /** ISO 8601 UTC. */
    postedAt: z.string(),
    ingestedAt: z.string(),
    conversationId: z.string().nullable(),
    replyToXPostId: z.string().nullable(),
    quotedXPostId: z.string().nullable(),
    metrics: postMetricsSchema,
    media: z.array(postMediaSchema),
    entities: postEntitiesSchema,
    /** ISO 8601 when X reported the author deleted it; null while it still stands. */
    deletedAt: z.string().nullable(),
    isRead: z.boolean(),
    isPinned: z.boolean(),
    note: z.string().nullable(),
    tags: z.array(tagDtoSchema),
    analysis: postAnalysisSchema.nullable(),
    author: postAuthorSchema,
});
//# sourceMappingURL=post.js.map